export default {"src":"/_next/static/media/assistant-builder-with-green-text-box.ffcc8173.svg","height":378,"width":291};